import React from 'react';
import InputCurrency from '~/components/Inputs/InputCurrency';
import Select from 'react-select';
import { Row, Col, Button } from 'reactstrap';

// Tipos disponíveis
const PAYMENT_TYPES = [
  { label: 'Pix', value: 'pix' },
  { label: 'Cartão de Crédito', value: 'credit_card' },
];

const SplitRulesSection = ({ dynamicRules, setDynamicRules }) => {
  const addRule = () => {
    const hasIncomplete = dynamicRules.some(rule => !rule.payment_type);
    if (hasIncomplete) {
      return; // Bloqueia a adição se existir uma regra sem tipo selecionado
    }
    setDynamicRules([...dynamicRules, { payment_type: null, amount: '' }]);
  };

  const removeRule = index => {
    const updated = [...dynamicRules];
    updated.splice(index, 1);
    setDynamicRules(updated);
  };

  const updateRulePaymentType = (index, value) => {
    const updated = [...dynamicRules];
    updated[index].payment_type = value;
    setDynamicRules(updated);
  };

  const updateRuleAmount = (index, value) => {
    const updated = [...dynamicRules];
    updated[index].amount = value;
    setDynamicRules(updated);
  };

  const getAvailableOptions = currentIndex => {
    const selectedTypes = dynamicRules
      .filter((_, idx) => idx !== currentIndex)
      .map(r => r.payment_type);
    return PAYMENT_TYPES.filter(
      option => !selectedTypes.includes(option.value)
    );
  };

  return (
    <>
      <Row className="w-100 mx-0 mb-3 justify-content-end">
        <Col lg="auto" className="px-0">
          <Button
            color="primary"
            disabled={dynamicRules.length >= PAYMENT_TYPES.length}
            onClick={addRule}
          >
            Adicionar Regra de Pagamento
          </Button>
        </Col>
      </Row>

      {dynamicRules.map((rule, index) => (
        <Row
          key={rule.payment_type}
          className="w-100 mx-0 mb-3 align-items-center"
        >
          <Col lg={5} className="px-0 pr-lg-2">
            <Select
              value={PAYMENT_TYPES.find(p => p.value === rule.payment_type)}
              options={getAvailableOptions(index)}
              onChange={selected =>
                updateRulePaymentType(index, selected.value)
              }
              placeholder="Tipo de Pagamento"
              classNamePrefix="select"
            />
          </Col>
          <Col lg={5} className="px-0 pl-lg-2">
            <InputCurrency
              name={`rule-amount-${index}`}
              placeholder="Valor Fixo (R$)"
              type="text"
              value={rule.amount}
              onValueChange={vals => updateRuleAmount(index, vals.floatValue)}
              currency
            />
          </Col>
          <Col lg={2} className="d-flex justify-content-center">
            <Button color="danger" onClick={() => removeRule(index)}>
              Remover
            </Button>
          </Col>
        </Row>
      ))}
    </>
  );
};

export default SplitRulesSection;
